// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root___9DQs","range":"MonthRangeSwitch_range__bDrQX","disabled":"MonthRangeSwitch_disabled__9teoP"};